'use client';
import FacebookPixel from '@/components/ui/FacebookPixel';
import {GoogleTagManager} from '@next/third-parties/google'
import { useState, useEffect } from "react";

export const Analytics = () => {
    const [allCookiesAllowed, setAllCookiesAllowed] = useState<boolean>(false);

    const handleStorageChange = () => {
        const consent = localStorage.getItem('cookieConsent');

        if (consent === 'all') {
            setAllCookiesAllowed(true)
        }
    }

    useEffect(() => {
        window.addEventListener('storage', handleStorageChange);
        window.addEventListener('cookieConsentChanged', handleStorageChange);

        handleStorageChange();

        return () => {
            window.removeEventListener('storage', handleStorageChange);
            window.removeEventListener('cookieConsentChanged', handleStorageChange);
          };
    }, [])

    return (
        allCookiesAllowed && (
            <>
              <GoogleTagManager gtmId="GTM-PPR83T29"/>
              <FacebookPixel />
            </>
        ))
}